export default __webpack_public_path__ + "static/token_holder-a1fa5e080d98b7c66bdd11821678b2d0.png";